import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class NoelGuard implements CanActivate {
  /** Prépare les dépendances utilisées pour décider si la navigation est autorisée. */
  constructor(private auth: AuthService, private router: Router) {}

  /** Autorise la navigation si la session possède les droits attendus. */
  canActivate(): boolean | UrlTree {
    if (!this.auth.isLoggedIn()) {
      return this.router.createUrlTree(['/login']);
    }
    const roles = this.auth.getRoles();
    if (roles.includes('ADMIN') || roles.includes('NOEL')) {
      return true;
    }
    return this.router.createUrlTree(['/access-denied']);
  }
}

